
export class PrintUtil {

  static generateAgeGenderString(patientInfo: any): string {
    let ageGender = '';
    if (patientInfo?.age) {
      ageGender =  `${patientInfo.age} Years`;
    }
    if (patientInfo?.gender) {
      ageGender += ` / ${patientInfo.gender.toUpperCase()}`;
    }
    return ageGender
  }

  static toUpperCaseText(text: string | undefined): string {
    return text ? text.toUpperCase() : text;
  }

}